import { render, staticRenderFns } from "./EmbedView.vue?vue&type=template&id=7b0d98f1&scoped=true"
import script from "./EmbedView.vue?vue&type=script&lang=js"
export * from "./EmbedView.vue?vue&type=script&lang=js"
import style0 from "./EmbedView.vue?vue&type=style&index=0&id=7b0d98f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0d98f1",
  null
  
)

export default component.exports